import { v4 as uuidv4 } from "uuid"

import * as types from "../types/printers"

export const fetchPrinters = () => {
  const printers =
    JSON.parse(localStorage.getItem("printers") || "[]")

  return {
    type: types.FETCH_PRINTERS,
    printers
  }
}

export const addPrinter = newPrinter => {
  const printers =
    JSON.parse(localStorage.getItem("printers") || "[]")

  printers.push(newPrinter)

  localStorage.setItem(
    "printers",
    JSON.stringify(printers)
  )

  return {
    type: types.ADD_PRINTER,
    newPrinter
  }
}

export const editPrinter = (printerId, data) => {
  const printers =
    JSON.parse(localStorage.getItem("printers") || "[]")

  const newPrinters =
    printers.map(p =>
      p._id === printerId ? data : p
    )

  localStorage.setItem(
    "printers",
    JSON.stringify(newPrinters)
  )

  return {
    type: types.EDIT_PRINTER,
    printerId,
    data
  }
}

export const deletePrinter = printerId => {
  const printers =
    JSON.parse(localStorage.getItem("printers") || "[]")

  const newPrinters =
    printers.filter(p => p._id !== printerId)

  localStorage.setItem(
    "printers",
    JSON.stringify(newPrinters)
  )

  return {
    type: types.DELETE_PRINTER,
    printerId
  }
}

export const addPosPrinter = () => {
  const newPrinter = {
    _id: uuidv4(),
    printerName: "POS",
    printerModel: "thermal",
    printerInterface: "usb",
    macAddress: "",
    deviceName: "",
    deviceId: 0,
    pageSize: "",
    ipAddress: "",
    port: "",
    printerWidth: 58,
    printerPaperWidth: 48,
    printerResolution: 8,
    printerType: "epson",
    vendorId: 0,
    productId: 0,
    forPos: true,
    forQrTable: true,
    forCustomer: true,
    forKitchen: false,
    forShiftReport: true,
    forOrderItems: false,
    forCourierLabel: false,
    categoryIds: []
  }

  const printers =
    JSON.parse(localStorage.getItem("printers") || "[]")

  printers.push(newPrinter)

  localStorage.setItem(
    "printers",
    JSON.stringify(printers)
  )

  return {
    type: types.ADD_PRINTER,
    newPrinter
  }
}